import React from "react";

const Contact = () => {
  return (
    <div className="home-content-wrapper">
      <div className="home-content">
        <h1 className="contact-title">You can find me here.</h1>
        <ul className="contact-nav">
          <li className="nav-padding">
            <a
              href="https://linkedin.com/in/nuno-gervasio"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              LinkedIn
            </a>
          </li>
          <li className="nav-padding">
            <a
              href="https://github.com/nunogervasio"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              Github
            </a>
          </li>
          <li className="nav-padding">
            <a
              href="mailto:nunogee@gmail.com?subject=Hey Nuno!"
              className="underline"
            >
              Email
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Contact;
